
import {Facebook, Twitter, Wifi, Youtube, Instagram} from 'react-bootstrap-icons';
import madeinjlm from '../res/madeinjlm.png';
const SocialAndStore = (width, height, format, cssClasses) => {
   

  return (
        <div id="ftr_icons" className={"SocialAndStore row " + cssClasses}> 
              
                    <div className="row"> 
                    <div className="col-6 col-md-3 col-lg-1"><a href="https://v2013.02ws.co.il/small/?tempunit=%C2%B0c&section=Api&lang=1" id="rss"><Wifi color="white" size={36}/></a></div>
                    <div className="col-6 col-md-3 col-lg-1"><a href="https://twitter.com/YERU02WS" target="_blank" id="twitter"><Twitter color="white" size={36}/></a></div>
                    <div className="col-6 col-md-3 col-lg-1"><a href="https://www.youtube.com/@02ws94" target="_blank" id="twitter"><Youtube color="white" size={36}/></a></div>
                    <div className="col-6 col-md-3 col-lg-1"><a href="https://www.instagram.com/jerusky02ws" target="_blank" id="twitter"><Instagram color="white" size={36}/></a></div>
                    <div className="col-6 col-md-3 col-lg-1"><a href="https://www.facebook.com/pages/02ws-ירושמיים-מזג-האוויר-בזמן-אמת/118726368187010" target="_blank" id="facebook"><Facebook color="white" size={36}/></a>
                         <iframe src="https://www.facebook.com/plugins/like.php?href=http%3A%2F%2Fwww.facebook.com%2Fpages%2FJerusalem-Israel%2F02ws-yrwsmyym-mzg-hwwyr-bzmn-mt%2F118726368187010&amp;layout=button_count&amp;show_faces=true&amp;width=100&amp;action=like&amp;colorscheme=light&amp;height=21" style={{width:'100px', height:'20px'}} ></iframe>
                    </div>
                   
                    <div className="col-6 col-md-3 col-lg-2">
                       <a href="https://play.google.com/store/apps/details?id=il.co.jws.app" target="_blank">
                        <img src="https://v2013.02ws.co.il/images/getitongp.svg" alt="Google play App" width="150" height="60"/>
                      </a>
                    </div> 
                    <div className="col-6 col-md-3 col-lg-2">
                      <a href="https://itunes.apple.com/us/app/yrwsmyym/id925504632?ls=1&mt=8" target="_blank">
                              <img src="https://v2013.02ws.co.il/images/Available_on_the_App_Store.svg" alt="App Store App" width="150" height="60"/>
                      </a>
                    </div>
                    <div className="col-6 col-md-3 col-lg-2">
                         <img src={madeinjlm} alt="Made in JLM" width="150"/>
                      
                    </div>
                    </div>
               
        </div>
       
    );
}

export default SocialAndStore; 